export type We88SeasonalPromotionVariant = 'world-cup-fever' | 'resumes' | 'fixture-frenzy';

export const WE88_SEASONAL_PROMOTION_ALLOWED_SUBSIDIARIES = ['w8m', 'w8i', 'w8t', 'w8v'] as const;

export const isWe88SeasonalPromotionSubsidiary = (
	subsidiaryOpratorId?: string | null,
): boolean => {
	if (subsidiaryOpratorId == null || String(subsidiaryOpratorId).trim() === '') {
		return false;
	}
	const normalizedSubsidiary = String(subsidiaryOpratorId).trim().toLowerCase();
	return WE88_SEASONAL_PROMOTION_ALLOWED_SUBSIDIARIES.some(
		(allowed) => allowed.toLowerCase() === normalizedSubsidiary,
	);
};

export const WE88_SEASONAL_PROMOTION_IMAGE_PATHS: Record<We88SeasonalPromotionVariant, string> = {
	'world-cup-fever': '/images/promotion/we88/world-cup-fever.jpg',
	resumes: '/images/promotion/we88/football-league-resumes.jpg',
	'fixture-frenzy': '/images/promotion/we88/football-league-fixture-frenzy.jpg',
};

export const WE88_SEASONAL_PROMOTION_CTA_ROUTES: Record<We88SeasonalPromotionVariant, string> = {
	'world-cup-fever': '',
	resumes: '/sports/1/l',
	'fixture-frenzy': '/sports/1/l',
};

export const WE88_SEASONAL_PROMOTION_ALT_TEXT: Record<We88SeasonalPromotionVariant, string> = {
	'world-cup-fever': 'World Cup Fever',
	resumes: 'Football League Resumes',
	'fixture-frenzy': 'Football League Fixture Frenzy',
};
